import { landingApi } from 'Pages/landings/common/api'
import { OrderCreateParams, OrderModel } from 'Pages/landings/common/types'

export const getQuery = () => {
	const { location } = window
	const params = location.search
		.substr(1)
		.split('&')
		.map((el) => el.split('='))
	return params.reduce((acc, [key, value]) => {
		acc[key] = value ? decodeURIComponent(value) : value
		return acc
	}, {} as Record<string, string>)
}

export const formatDate = (date: Date) =>
	date.toLocaleDateString('ru-RU', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	})

export const formatDateForBackend = (date: string) =>
	new Date(date).toLocaleDateString('sv-SE', {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
	})

export const getParamsFromUrl = () => {
	const params = getQuery()
	return {
		url: window.location.href,
		source: params.source,
		utm_medium: params.utm_medium,
		utm_campaign: params.utm_campaign,
		utm_content: params.utm_content,
	}
}

export const concatNames = <T extends { id: string | number; name: string }>(
	data: T[] = []
): string => {
	return data.reduce(
		(acc: string, item: T): string =>
			acc && acc.length ? `${acc},  ${item.name} ` : `${item.name}`,
		''
	)
}

export const getMinCompanyExistErrorText = (error: Record<string, any>) => {
	const productsErrors = error.min_company_existence_check_failed
	if (!productsErrors) return ''
	const productNames = concatNames(
		Array.isArray(productsErrors) ? productsErrors : [productsErrors]
	)
	return [productsErrors].length === 1
		? `Подача заявки невозможна. Срок ведения бизнеса не соответствует требованиям к продукту ${productNames}`
		: `Подача заявки невозможна. Срок ведения бизнеса не соответствует требованиям к продуктам:  ${productNames}`
}

export const normalizePhone = (value) => {
	if (!value) return value
	if (value.length === 1) {
		return `+7${value.replace(/[^\d]/g, '')}`
	}
	if (value === '+7') {
		return null
	}
	const onlyNums = value.replace(/[^\d]/g, '')
	return `+${onlyNums}`
}

export const submitLeadAndOrder = (
	parent_id: number | null,
	paramsOrder: OrderCreateParams,
	token: string,
	regionName: string | undefined,
	callback: (res: OrderModel) => void,
	errorCallback: (res: Record<string, string>) => void
) => {
	const { createOrder, postLeadCreate } = landingApi
	let org_type = paramsOrder?.inn?.length === 10 ? 'ooo' : paramsOrder?.inn
	if (paramsOrder?.inn?.length === 12) org_type = 'ip'
	const timezone = -(new Date().getTimezoneOffset() / 60)
	const currentTimezone = timezone > 0 ? `+${String(timezone)}` : String(timezone)
	postLeadCreate({
		org_type,
		parent_id,
		parent_type: 'SberMq::ExternalForm',
		bearer: 'digital',
		empty_middle_name: true,
		phone: paramsOrder?.phone,
		inn: paramsOrder?.inn,
		first_name: paramsOrder?.first_name ?? '',
		timezone: currentTimezone,
		area_name: regionName ?? '',
	})
		.then((response) => {
			if (response) return createOrder(paramsOrder, token).then((response) => callback(response))
		})
		.catch((error) => errorCallback(error.data.errors))
}
